import { ArrowUpRight, Volume2 } from "lucide-react";
import TopBar from "./TopBar";
import IncomingCallCard from "./IncomingCallCard";
import { Ticker } from "./SampleCarousel";
import { useSamples } from "./SamplesContext";

export default function Hero() {
  const { play } = useSamples();
  return (
    <section className="hero" data-testid="hero">
      <TopBar />
      <div className="relative z-10 mx-auto grid max-w-7xl gap-10 px-5 pb-24 pt-28 sm:px-8 lg:min-h-[100svh] lg:grid-cols-[1fr_minmax(0,560px)] lg:content-center lg:items-start lg:gap-14 lg:pb-20 lg:pt-28">
        <div>
          <p className="rise inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs text-[var(--cream)]/80" style={{ "--d": 1 }}>
            <span className="pulse-dot h-2 w-2 rounded-full bg-[var(--orange)]" /> Now in Telugu. More Indian languages coming soon.
          </p>
          <h1 className="rise mt-5 text-4xl font-extrabold leading-[0.98] tracking-tight sm:text-5xl xl:text-6xl" style={{ "--d": 2 }} data-testid="hero-headline">
            Every medicine, <span className="font-serif-i font-normal text-[var(--orange)]">on time.</span>
          </h1>
          <p className="rise font-te mt-4 text-2xl font-semibold text-[var(--cream)] sm:text-3xl" style={{ "--d": 3 }} data-testid="hero-telugu-tagline">ప్రతి మందు, సమయానికి.</p>
          <p className="rise mt-4 max-w-md text-base text-[var(--cream)]/75 md:text-lg" style={{ "--d": 4 }}>
            Daily reminder calls in your patient's own language — in your hospital's name.
          </p>
          <p className="rise mt-3 max-w-lg border-l-2 border-[var(--orange)] pl-3 text-sm text-[var(--cream)]/65" style={{ "--d": 4 }} data-testid="hero-positioning-line">
            Other companies build call-centre bots for big hospitals. OnDose does one thing: makes sure your patients take every medicine, and come back to you.
          </p>
          <div className="rise mt-7 flex flex-wrap items-center gap-3" style={{ "--d": 5 }}>
            <button onClick={() => play(0)} data-testid="hero-sample-call-btn" className="btn-orange inline-flex items-center gap-2 rounded-2xl px-5 py-3.5 font-semibold">
              <Volume2 size={18} /> Hear a sample call
            </button>
            <a href="#demo" data-testid="hero-request-demo-btn" className="inline-flex items-center gap-2 rounded-2xl border border-white/25 px-5 py-3.5 font-semibold text-[var(--cream)] transition-colors hover:bg-white/10">
              Request a demo <ArrowUpRight size={18} />
            </a>
          </div>
          <div className="rise mt-6 w-full max-w-[520px]" style={{ "--d": 6 }}>
            <IncomingCallCard compact />
          </div>
        </div>

        <div className="rise hero-arch-wrap lg:mt-10" style={{ "--d": 3 }} data-testid="hero-family-wrap">
          <div className="hero-arch" data-testid="hero-arch">
            <div className="hero-photo">
              <img src="/img/hero-family-v2.webp" alt="An Indian family on a bench — the grandmother smiles as she takes a phone call while her daughter, granddaughter and son look on" data-testid="hero-mascot" draggable="false" />
              <span className="phone-ring" aria-hidden="true" data-testid="hero-phone-ring"><i /><i /><i /></span>
            </div>
          </div>
        </div>
      </div>
      <Ticker />
    </section>
  );
}
